import React, { useState } from 'react';
import { Send, CheckCircle, User, Mail, Phone, Building2, MessageSquare, Globe } from 'lucide-react';
import './IntakeForm.css';

const IntakeForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    business: '',
    website: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          access_key: 'f6ab0418-f6aa-47f5-b1da-89cb2a4503f4',
          subject: `💬 General Enquiry from ${formData.name} | ${formData.business}`,
          from_name: formData.name,
          replyto: formData.email,
          'Name': formData.name,
          'Email': formData.email,
          'Phone': formData.phone || 'Not provided',
          'Business': formData.business,
          'Website': formData.website || 'None',
          'Message': formData.message || 'No message provided',
        }),
      });

      const data = await response.json();
      if (data.success) {
        setSubmitted(true);
      } else {
        alert('Something went wrong. Please try again.');
      }
    } catch (err) {
      alert('Connection error. Please try again.');
    }

    setLoading(false);
  };

  return (
    <section className="intake section" id="get-started">
      <div className="container">
        <div className="intake__wrapper">
          <div className="intake__info">
            <span className="section-label">Get Started</span>
            <h2 className="section-title">Ready to go live?<br />Let's talk.</h2>
            <p className="intake__desc">
              Not sure which package is right for you? Send us a message and we'll
              help you figure it out. No commitment required.
            </p>

            <div className="intake__benefits">
              {[
                'Free consultation & quote',
                'No obligation — just a conversation',
                'Response within 24 hours',
                '50% upfront, 50% on delivery',
              ].map((benefit, i) => (
                <div key={i} className="intake__benefit">
                  <div className="intake__benefit-icon">
                    <CheckCircle size={16} />
                  </div>
                  <span>{benefit}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="intake__form-wrapper">
            {!submitted ? (
              <form className="intake__form" onSubmit={handleSubmit}>
                <div className="intake__field">
                  <label htmlFor="intake-name"><User size={14} /> Full Name</label>
                  <input type="text" id="intake-name" name="name" placeholder="John Smith" value={formData.name} onChange={handleChange} required />
                </div>

                <div className="intake__row">
                  <div className="intake__field">
                    <label htmlFor="intake-email"><Mail size={14} /> Email</label>
                    <input type="email" id="intake-email" name="email" placeholder="john@business.com" value={formData.email} onChange={handleChange} required />
                  </div>
                  <div className="intake__field">
                    <label htmlFor="intake-phone"><Phone size={14} /> Phone</label>
                    <input type="tel" id="intake-phone" name="phone" placeholder="+1 (555) 000-0000" value={formData.phone} onChange={handleChange} />
                  </div>
                </div>

                <div className="intake__field">
                  <label htmlFor="intake-business"><Building2 size={14} /> Business Name</label>
                  <input type="text" id="intake-business" name="business" placeholder="Your Business Name" value={formData.business} onChange={handleChange} required />
                </div>

                <div className="intake__field">
                  <label htmlFor="intake-website"><Globe size={14} /> Current Website (if any)</label>
                  <input type="url" id="intake-website" name="website" placeholder="https://yourbusiness.com" value={formData.website} onChange={handleChange} />
                </div>

                <div className="intake__field">
                  <label htmlFor="intake-message"><MessageSquare size={14} /> Tell us about your project</label>
                  <textarea id="intake-message" name="message" placeholder="What does your business do? What are you looking for in a website?" rows="4" value={formData.message} onChange={handleChange} />
                </div>

                <button type="submit" className="btn-primary intake__submit" disabled={loading}>
                  <Send size={18} />
                  {loading ? 'Sending...' : 'Send Enquiry'}
                </button>
              </form>
            ) : (
              <div className="intake__success">
                <div className="intake__success-icon">
                  <CheckCircle size={52} />
                </div>
                <h3>We've got your details!</h3>
                <p>
                  Expect a reply within 24 hours with your custom project plan and
                  timeline. We're excited to bring your vision to life.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntakeForm;
